import React from 'react';
import LazyLoad from 'Common/pages/LazyLoad';

const fullViewportStyle: React.CSSProperties = {
  minHeight: '100%',
  width: '100%',
};

const withWaitingComponent = (Component: React.ComponentType) => (
  <div style={fullViewportStyle}>
    <LazyLoad>
      <Component />
    </LazyLoad>
  </div>
);
export default withWaitingComponent;
